// frontend/src/component/HomeCategoryChips.jsx
import { Link } from "react-router-dom";

export default function CategoryChips({ categories = [] }) {
  if (!Array.isArray(categories) || categories.length === 0) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 mt-6 touch-pan-y">
      {/* Сетка: на мобилке 2 колонки, дальше — 4; никаких overflow */}
      <ul className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {categories.map((c) => (
          <li key={c.id}>
            <Link
              to={c.href}
              className="block rounded-xl border border-gray-200 bg-white px-3 py-3 text-sm font-medium text-gray-800
                         shadow-sm hover:border-orange-400 hover:text-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300"
            >
              <span className="block truncate">{c.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
